import { render, staticRenderFns } from "./userAndAccount.vue?vue&type=template&id=0d6bddf7&scoped=true&"
import script from "./userAndAccount.vue?vue&type=script&lang=js&"
export * from "./userAndAccount.vue?vue&type=script&lang=js&"
import style0 from "./userAndAccount.vue?vue&type=style&index=0&id=0d6bddf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6bddf7",
  null
  
)

export default component.exports